import React, { useEffect, useState } from "react";
import { exchangeDate, getDateString } from "../../helpers";
import { Config } from "../../Config";

const PresentDateTimeDisplay = () => {
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const timeZone = Config.timeZone === "local" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "America/New_York";
      // Format time as 12-hour with AM/PM
      const timeString = now.toLocaleTimeString("en-US", {
        timeZone,
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
      });
      setCurrentTime(timeString);
    };

    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="docpro_current_time_show">
      <div className="docpro_tip_checkbox">
        {currentTime}<br/>
        {exchangeDate(getDateString())}
        <span className="docpro_tip" style={{ textAlign: 'center' }}>{Config.timeZone === "local" ? "Local time" : "New York Time"}</span>
      </div>
    </div>
  );
};

export default PresentDateTimeDisplay;
